/* unplugin-vue-components disabled */import script from "./Detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./Detail.vue?vue&type=script&setup=true&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=3359f20d&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3359f20d"]])

export default __exports__